import React, { useCallback } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { AppButton, Box, InfoOutlineIcon, Preloader, Text } from '@common-fe/common-fe';

import { ROUTES } from '@/common';

import useGetBeneficiariesQuery from '../Employee/Beneficiaries/useGetBeneficiaries.query';
import { useHasAccessToViewBeneficiaries } from '../Employee/Beneficiaries/useHasBeneficiaryAccess';
import { MODULES } from '../Employee/EmployeeSidebar/hooks/useEmployeeModules';

import { IconWrapper } from './AccountDetails.styles';

const BeneficiaryInfo = () => {
  const hasAccessToViewBeneficiaries = useHasAccessToViewBeneficiaries();
  const { isLoading, formattedData } = useGetBeneficiariesQuery(hasAccessToViewBeneficiaries);
  const { params: { id: employeeId } } = useRouteMatch<{ id: string }>();
  const history = useHistory();
  const goToEditEmployeePage = useCallback(() =>
    history.push(`${ROUTES.EMPLOYEE_EDIT_VIEW(employeeId)}${history.location.search}#${MODULES.BENEFICIARIES}`),
  [employeeId, history]);

  if (!hasAccessToViewBeneficiaries || (!isLoading && formattedData?.length)) return null;

  return (
    <Box
      data-testId="BeneficiaryInfo"
      direction="row"
      background="canvas"
      round="container1Round"
      elevation="default"
      border={{ size: 'small', color: 'border2' }}
      justify="between"
      align="center"
      pad={{ horizontal: 'm', vertical: 's' }}
      margin={{ top: 'xs' }}
    >
      {isLoading ? <Preloader /> : (
        <>
          <Box direction="row">
            <IconWrapper direction="row" align="center" justify="center">
              <InfoOutlineIcon color="iconPrimary" />
            </IconWrapper>
            <Text
              margin={{ left: 'xs' }}
              size="large"
              color="textBody"
            >
              Don't forget to setup beneficiaries
            </Text>
          </Box>

          <AppButton
            buttonType="quaternary"
            onClick={goToEditEmployeePage}
          >
            Add Beneficiaries
          </AppButton>
        </>
      )}
    </Box>
  );
};

export default BeneficiaryInfo;
